<template>
  <div class="modal fade" id="viewFixedPayments" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="viewAllDdsLabel">View Direct Debits</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span><a class="close"><i class="far fa-times-circle fa-2x" data-dismiss="modal" id="closeAllBills"
                          aria-label="Close"></i></a></span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                        <span class="fa-stack fa-2x fsm float-right">
                          <i class="far fa-circle fa-stack-2x"></i>
                          <i class="fas fa-external-link-alt fa-stack-1x"></i>
                        </span>
                      </router-link> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-xl-12">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="table-div col-12 mt-3 pl-3 pr-3">
                        <b-table id="ddCollections" class="table-scroll tbl-sml" :items="fixedPayments"
                          :fields="fixedPaymentFields">
                          <template slot="FirstCollectionDue" slot-scope="data">
                            {{data.item.FirstCollectionDue | dateString}}
                          </template>
                          <template slot="DaysOfMonth" slot-scope="data">
                            <span v-for="(day, index) in data.item.DaysOfMonth" :key="index">
                              {{day | daySuffix()}}<span v-if="index <  data.item.DaysOfMonth.length - 2">,
                              </span><span v-if="index == data.item.DaysOfMonth.length - 2"> & </span></span>
                          </template>
                          <template slot="RegularCollectionAmount" slot-scope="data">
                            {{data.item.RegularCollectionAmount | currency}}
                          </template>
                          <template slot="NextCollectionDue" slot-scope="data">
                            {{data.item.NextCollectionDue | dateString}}
                          </template>
                          <template slot="EffectiveTo" slot-scope="data">
                            {{data.item.EffectiveTo | dateString}}
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _filters from '@/mixins/filters.js';

export default {
  mixins: [_filters],
  data() {
    return {
      fixedPaymentFields: {
        FirstCollectionDue: {
          label: 'First Collection',
        },
        DaysOfMonth: {
          label: 'Collection Day(s)',
        },
        RegularCollectionAmount: {
          label: 'Collection Amount',
        },
        NextCollectionDue: {
          label: 'Next Collection',
          sortable: true,
        },
        EffectiveTo: {
          label: 'Effective To',
        },
      },
    };
  },
  computed: {
    fixedPayments() {
      return this.$_.sortBy(
        this.$store.state.finances.fixedPayments,
        'FirstCollectionDue'
      ).reverse();
    },
  },
  filters: {
    dateString(date) {
      if (!date) return '';

      return moment(date).format('Do MMM YYYY');
    },
  },
};
</script>
